module.exports = "/images/EasyPedidoIcon16x16.png";